{
  "kk": {
    "lastName": "Тегі — латын әріптерімен",
    "firstName": "Аты — латын әріптерімен",
    "gender": {
      "label": "Жынысы",
      "male": "Еркек",
      "female": "Әйел"
    },
    "dateOfBirth": "Туылған күні",
    "citizenship": "Азаматтығы",
    "document": {
      "number": {
        "domestic": {
          "label": "Паспорт немесе жеке күәлік нөмірі",
          "placeholder": "N00000000 немесе 000000000"
        },
        "international": {
          "label": "Паспорт нөмірі",
          "placeholder": "N00000000"
        }
      },
      "expirationDate": "Құжаттың жарамдылық мерзімі",
      "expirationDateInternationalHint": "ҚР-ға қайтарда құжатыңыз кемі 6 ай жарамды болуы керек"
    },
    "iin": "ЖСН — Жеке сәйкестендіру нөмірі",
    "datePlaceholder": "КК.АА.ЖЖЖЖ",
    "expiresAt": "Құжаттың жарамдылық мерзімі",
    "givenAt": "Құжат берілген күн",
    "organization": {
      "label": "Құжатты кім берді",
      "placeholder": "Құжатты берген орган"
    },
    "fin": "ФИН - Жеке идентификация нөмірі",
    "series": {
      "label": "Құжаттың сериясы",
      "placeholder": "Әріпті код я цифрлы код",
      "hint": "Серия деген — жолаушының шетелдік паспортының нөміріндегі бір әріпті, екі әріпті, бір таңбалы я екі таңбалы код"
    },
    "close": "Жабу"
  },
  "ru": {
    "lastName": "Фамилия — на латинице",
    "firstName": "Имя — на латинице",
    "gender": {
      "label": "Выберите пол",
      "male": "Мужчина",
      "female": "Женщина"
    },
    "dateOfBirth": "Дата рождения",
    "citizenship": "Гражданство",
    "document": {
      "number": {
        "domestic": {
          "label": "№ паспорта или удв. личности",
          "placeholder": "N00000000 или 000000000"
        },
        "international": {
          "label": "№ паспорта",
          "placeholder": "N00000000"
        }
      },
      "expirationDate": "Срок действия документа",
      "expirationDateInternationalHint": "При возврате в РК до конца срока паспорта должно быть более 6 месяцев"
    },
    "iin": "ИИН — Индивидуальный идентификационный номер",
    "datePlaceholder": "ДД.ММ.ГГГГ",
    "expiresAt": "Срок действия документа",
    "givenAt": "Дата выдачи документа",
    "organization": {
      "label": "Кем выдан документ",
      "placeholder": "Орган, выдавший документ"
    },
    "fin": "ФИН - Персональный идентификационный номер",
    "series": {
      "label": "Серия документа",
      "placeholder": "Буквенный или цифровой код",
      "hint": "К серии относятся однобуквенные, двухбуквенные, однозначные или двузначные коды в номере иностранного паспорта пассажира"
    },
    "close": "Закрыть"
  },
  "en": {
    "lastName": "Last name — on Latin",
    "firstName": "First name — on Latin",
    "gender": {
      "label": "Select gender",
      "male": "Male",
      "female": "Female"
    },
    "dateOfBirth": "Date of birth",
    "citizenship": "Citizenship",
    "document": {
      "number": {
        "domestic": {
          "label": "Passport or ID number",
          "placeholder": "N00000000 or 000000000"
        },
        "international": {
          "label": "Passport number",
          "placeholder": "N00000000"
        }
      },
      "expirationDate": "Document expiration date",
      "expirationDateInternationalHint": "When returning to RK, the document must be more than 6 months valid"
    },
    "iin": "IIN — Individual identification number",
    "datePlaceholder": "DD.MM.YYYY",
    "expiresAt": "Document expiration date",
    "givenAt": "Document issue date",
    "organization": {
      "label": "Who issued the document",
      "placeholder": "Organization, issuing the document"
    },
    "fin": "FIN - Personal identification number",
    "series": {
      "label": "Document series",
      "placeholder": "Letter or numeric code",
      "hint": "Series includes one-letter, two-letter, one-digit or two-digit codes in the number of a foreign passport of the passenger"
    },
    "close": "Close"
  }
}
